<template>
    <div class="manuel-ban-modal wrapper">
        <Modal2
            v-if="internalBanModalVisible"
            class="custom-ban-modal"
            :title="$t('message.banModalTitle')"
            :ok-text="'Yasakla'"
            :cancel-text="$t('message.cancel')"
            @cancel="closeModal"
            @ok="suppressionProcess(type, value)"
        >
            <div class="ban-form-container">
                <a-form layout="vertical">
                    <div class="ban-form-header">
                        <span class="ban-form-title">
                           {{ $t("message.banModalDescription") }} 
                        </span>
                    </div>
                    
                    <a-form-item :label="$t('message.platform')">
                        <a-select 
                            id="type" 
                            v-model="type" 
                            v-validate="'required'" 
                            class="platform-select"
                            :placeholder="$t('auto.selectPlatform')"
                        >
                            <a-select-option v-for="item in types" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    
                    <a-form-item :label="$t('chatbotv2.value')">
                        <a-input 
                            v-model="value" 
                            :placeholder="getPlaceholderForType"
                            v-validate="'required'"
                            name="value"
                            :class="{ 'has-error': errors.has('value') }"
                        />
                        <div v-if="errors.has('value')" class="ant-form-explain error-text">
                            {{ errors.first('value') }}
                        </div>
                        <div class="help-text">
                            {{ getHelpTextForType }}
                        </div>
                    </a-form-item>
                    
                    <div class="ban-options">
                        <a-form-item :label="'Yasaklama Seçenekleri'">
                            <div class="ban-option-container">
                                <div class="switch-option" :class="{ 'active-option': inbound }">
                                    <div class="switch-header">
                                        <span class="switch-label">{{ $t("message.sendingAllow") }}</span>
                                        <a-switch
                                            class="ml-2 mr-2"
                                            checked-children="✖"
                                            un-checked-children="✔"
                                            v-model="inbound"
                                        />
                                    </div>
                                    <div class="switch-status">
                                        <span :class="inbound ? 'status-blocked' : 'status-allowed'">
                                            {{ inbound ? $t('message.bannedUser') : $t('message.unbannedUser') }}
                                        </span>
                                    </div>
                                </div>
                                
                                <div class="switch-option" :class="{ 'active-option': outbound }">
                                    <div class="switch-header">
                                        <span class="switch-label">{{ $t("message.receiving") }}</span>
                                        <a-switch
                                            class="ml-2 mr-2"
                                            checked-children="✖"
                                            un-checked-children="✔"
                                            v-model="outbound"
                                        />
                                    </div>
                                    <div class="switch-status">
                                        <span :class="outbound ? 'status-blocked' : 'status-allowed'">
                                            {{ outbound ? $t('message.bannedUser') : $t('message.unbannedUser') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a-form-item>
                    </div>
                </a-form>
            </div>
        </Modal2>
    </div>
</template>
<script>
import Modal2 from "./common/Modal2.vue";
import { SUPPRESSION_API } from "../api/suppression";
import { mapState } from "vuex";
import SupsisButton from "./common/SupsisButtonOld.vue";

export default {
    name: "VisitorManualBanModal",
    components: { Modal2, SupsisButton },
    props: {
        banModalVisible: {
            type: Boolean,
        },
    },
    data() {
        return {
            internalBanModalVisible: false,
            types: [
                {
                    id: "email",
                    name: "Mail"
                },
                {
                    id: "whatsapp",
                    name: "Whatsapp",
                },
                {
                    id: "web-visitor",
                    name: "Web Visitor"
                },
                {
                    id: "web-visitor-ip",
                    name: "IP Address"
                }
            ],
            type: "email",
            value: "",
            inbound: false,
            outbound: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        getPlaceholderForType() {
            switch (this.type) {
                case "email":
                    return "ornek@mail.com";
                case "whatsapp":
                    return "+901234567890";
                case "web-visitor":
                    return "visitor-id";
                case "web-visitor-ip":
                    return "192.168.1.1";
                default:
                    return "Lütfen değer giriniz."
            }
        },
        getHelpTextForType() {
            switch (this.type) {
                case "email":
                return this.$t("message.invalidEmailAddress") || "Lütfen geçerli bir e-posta adresi girin.";
                case "whatsapp":
                    return this.$t("message.enterValidWhatsappNumber") || "Lütfen geçerli bir WhatsApp numarası girin.";
                case "web-visitor":
                    return this.$t("message.enterValidVisitorId") || "Lütfen geçerli bir ziyaretçi kimliği girin.";
                case "web-visitor-ip":
                    return this.$t("message.enterValidIpAddress") || "Lütfen geçerli bir IP adresi girin.";
                default:
                    return "";
            }
        }
    },
    methods: {
        resetForm() {
            this.type = "";
            this.value = "";
            this.inbound = false;
            this.outbound = false;
        },
        validateValueFormat() {
            if (!this.type || !this.value) return false;

            switch (this.type) {
                case "email":
                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.value);
                case "whatsapp":
                    return /^\+?\d{10,15}$/.test(this.value);
                case "web-visitor-ip":
                    return /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(this.value);
                default:
                    return true;
            }
        },
        async suppressionProcess(type, value) {
            const isValid = await this.$validator.validateAll();
            
            if (!isValid) {
                return;
            }

            if (!this.inbound && !this.outbound) {
                this.$toasted.error(this.$t("message.selectAtLeastOneOption"), {
                    duration: 3000,
                    position: "bottom-center",
                    className: ["yellow-toast"],
                    icon: "warning",
                });
                return;
            }

            if (!this.validateValueFormat()) {
                this.$toasted.error(this.$t("message.enterValidValue"), {
                    duration: 3000,
                    position: "bottom-center",
                    icon: "error",
                });
                return;
            }

            try {
                SUPPRESSION_API.update(type, value, this.inbound, this.outbound, this.user._id);
                this.$emit("update");
                this.$message.success({
                    content: this.$t("message.bannedUserSuccess"),
                    duration: 2,
                    key: "saved",
                });
                this.resetForm();
                this.closeModal();
            } catch (error) {
                this.$toasted.error(this.$t("message.bannedUserError"), {
                    duration: 3000,
                    position: "bottom-center",
                    icon: "error",
                });
            }
        },
        closeModal() {
            this.internalBanModalVisible = false;
            this.$emit("close");
        },
    },
    watch: {
        banModalVisible: {
            immediate: true,
            handler(val) {
                this.internalBanModalVisible = val;
            },
        },
    },
};
</script>
<style lang="scss">
.custom-ban-modal {
    .ant-modal {
        width: 500px !important;
        z-index: 3000;
        
        .ant-modal-content {
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
            
            .ant-modal-body {
                padding: 0;
            }
            
            .ant-modal-header {
                background-color: #f7f7f7;
                border-bottom: 1px solid #eaeaea;
                padding: 16px 24px;
                
                .ant-modal-title {
                    font-weight: 600;
                    color: rgba(0, 0, 0, 0.85);
                }
            }
            
            .ant-modal-footer {
                border-top: 1px solid #eaeaea;
                padding: 16px 24px;
                
                .ant-btn {
                    height: 36px;
                    border-radius: 4px;
                    font-weight: 500;
                    transition: all 0.3s ease;
                    
                    &.ant-btn-primary {
                        background-color: #1890ff;
                        border-color: #1890ff;
                        
                        &:hover, &:active, &:focus {
                            background-color: #40a9ff;
                            border-color: #40a9ff;
                        }
                    }
                    
                    &:not(.ant-btn-primary) {
                        &:hover, &:active, &:focus {
                            color: #1890ff;
                            border-color: #1890ff;
                        }
                    }
                }
            }
        }
    }
    
    .ban-form-container {
        padding: 24px;
        
        .ban-form-header {
            margin-bottom: 24px;
            
            .ban-form-title {
                font-size: 14px;
                color: rgba(0, 0, 0, 0.65);
            }
        }
        
        .ant-form-item {
            margin-bottom: 18px;
            
            .ant-form-item-label {
                label {
                    color: rgba(0, 0, 0, 0.85);
                    font-weight: 500;
                }
            }
            
            .ant-select {
                &.platform-select {
                    width: 100%;
                    
                    .ant-select-selection {
                        border-radius: 4px;
                        border-color: #d9d9d9;
                        transition: all 0.3s ease;
                        
                        &:hover, &:focus, &:active {
                            border-color: #40a9ff;
                        }
                    }
                }
            }
            
            .ant-input {
                border-radius: 4px;
                padding: 8px 12px;
                height: 36px;
                transition: all 0.3s ease;
                
                &:hover, &:focus {
                    border-color: #40a9ff;
                    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
                }
                
                &.has-error {
                    border-color: #f5222d !important;
                    
                    &:hover, &:focus {
                        box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
                    }
                }
            }
            
            .help-text {
                color: rgba(0, 0, 0, 0.45);
                font-size: 12px;
                margin-top: 4px;
            }
            
            .error-text {
                color: #f5222d;
                font-size: 12px;
                margin-top: 4px;
            }
        }
        
        .ban-options {
            margin-top: 24px;
            
            .ban-option-container {
                display: flex;
                flex-direction: column;
                gap: 16px;
                
                .switch-option {
                    display: flex;
                    flex-direction: column;
                    padding: 16px;
                    border-radius: 8px;
                    border: 1px solid #f0f0f0;
                    transition: all 0.2s ease;
                    
                    &:hover {
                        border-color: #d9d9d9;
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
                    }
                    
                    &.active-option {
                        background-color: #fafafa;
                        border-color: #d9d9d9;
                    }
                    
                    .switch-header {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                        
                        .switch-label {
                            font-size: 14px;
                            font-weight: 500;
                        }
                        
                        .ant-switch {
                            min-width: 44px;
                            height: 22px;
                            
                            &.ant-switch-checked {
                                background-color: #f5222d;
                                
                                &:hover:not(.ant-switch-disabled) {
                                    background-color: #ff4d4f;
                                }
                                
                                .ant-switch-handle {
                                    &::before {
                                        background-color: #fff;
                                    }
                                }
                            }
                            
                            &:not(.ant-switch-checked) {
                                background-color: #52c41a;
                                
                                &:hover:not(.ant-switch-disabled) {
                                    background-color: #73d13d;
                                }
                                
                                .ant-switch-handle {
                                    &::before {
                                        background-color: #fff;
                                    }
                                }
                            }
                        }
                    }
                    
                    .switch-status {
                        margin-top: 12px;
                        
                        span {
                            padding: 4px 10px;
                            border-radius: 12px;
                            font-size: 12px;
                            display: inline-block;
                            
                            &.status-blocked {
                                color: #fff;
                                background-color: #ff4d4f;
                            }
                            
                            &.status-allowed {
                                color: #fff;
                                background-color: #52c41a;
                            }
                        }
                    }
                }
            }
        }
    }
}

.toasted-container {
    z-index: 9999999999999 !important;
}

.yellow-toast {
    background-color: #ff9700 !important;
    color: white !important;
}
</style>
